<template>
  <a-modal
    title="编辑医院不良事件表"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="事件发生时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择事件发生时间" v-decorator="['eventOccurTime',{rules: [{ required: true, message: '请选择事件发生时间！' }]}]" @change="onChangeeventOccurTime"/>
        </a-form-item>
        <a-form-item
          label="标题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入标题" v-decorator="['title', {rules: [{required: true, message: '请输入标题！'}]}]" />
        </a-form-item>
        <a-form-item
          label="描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-textarea :rows="4"   v-decorator="['description', {rules: [{required: true, message: '请描述！'}]}]" ></a-textarea>
        </a-form-item>
        <!-- <a-form-item
          label="删除标识（0-否，1-是）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入删除标识（0-否，1-是）" v-decorator="['deleteFlag', {rules: [{required: true, message: '请输入删除标识（0-否，1-是）！'}]}]" />
        </a-form-item> -->
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baAdverseEventEdit } from '@/api/modular/main/baadverseevent/baAdverseEventManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        eventOccurTimeDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              title: record.title,
              description: record.description,
              deleteFlag: record.deleteFlag
            }
          )
        }, 100)
        // 时间单独处理
        if (record.eventOccurTime != null) {
            this.form.getFieldDecorator('eventOccurTime', { initialValue: moment(record.eventOccurTime, 'YYYY-MM-DD') })
        }
        this.eventOccurTimeDateString = moment(record.eventOccurTime).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.eventOccurTime = this.eventOccurTimeDateString
            values.deleteFlag = 0
            baAdverseEventEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangeeventOccurTime(date, dateString) {
        this.eventOccurTimeDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
